import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../contexts/authProvider';

const TierGuard = ({ allowedTiers, children }) => {
  const { user } = useContext(AuthContext);
  const userTier = user?.user_tier || 'user';

  if (!allowedTiers.includes(userTier)) {
    return <Navigate to="/selectmenu" replace />;
  }

  return children;
};

export default TierGuard;
